/**
 * App updates. The desktop app asks the update server for a newer, signed
 * release shortly after it starts; the banner and the settings row share this
 * state. Outside the desktop app there is nothing to update.
 */

import { checkForUpdate, installUpdate, type UpdateInfo } from './tauri'
import { canSelfUpdate } from './platform'

export const update = $state<{
  available: UpdateInfo | null
  checking: boolean
  installing: boolean
  error: string
  /** True after a manual check found nothing, so the UI can say so. */
  upToDate: boolean
}>({ available: null, checking: false, installing: false, error: '', upToDate: false })

/** Look for an update. `quiet` hides failures: a background check that cannot reach the server is not news. */
export async function checkNow(quiet = false): Promise<void> {
  if (!canSelfUpdate || update.checking || update.installing) return
  update.checking = true
  update.error = ''
  update.upToDate = false
  try {
    update.available = await checkForUpdate()
    update.upToDate = update.available === null
  } catch (err) {
    if (!quiet) update.error = err instanceof Error ? err.message : String(err)
  } finally {
    update.checking = false
  }
}

/** Download, verify and install; the app restarts when it works. */
export async function installNow(): Promise<void> {
  if (!canSelfUpdate || update.installing) return
  update.installing = true
  update.error = ''
  try {
    await installUpdate()
  } catch (err) {
    update.error = err instanceof Error ? err.message : String(err)
    update.installing = false
  }
}

if (canSelfUpdate) setTimeout(() => void checkNow(true), 8000)
